var _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrderDetailChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FC2B6E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 14.2C14.2222 13.7582 14.5704 13.4 15 13.4H18.1111C18.5407 13.4 18.8889 13.7582 18.8889 14.2C18.8889 14.6418 18.5407 15 18.1111 15H15C14.5704 15 14.2222 14.6418 14.2222 14.2Z",
    fill: "#FC2B6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.8C14.5704 15.8 14.2222 16.1582 14.2222 16.6C14.2222 17.0418 14.5704 17.4 15 17.4H18.1111C18.5407 17.4 18.8889 17.0418 18.8889 16.6C18.8889 16.1582 18.5407 15.8 18.1111 15.8H15Z",
    fill: "#FC2B6E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.6C8 7.71634 8.69645 7 9.55556 7H18.1111C18.9702 7 19.6667 7.71634 19.6667 8.6V10.2H20.4444C21.3036 10.2 22 10.9163 22 11.8V21.4C22 22.2837 21.3036 23 20.4444 23H12.6667C11.8076 23 11.1111 22.2837 11.1111 21.4V20.6H9.55556C8.69645 20.6 8 19.8837 8 19V8.6ZM18.332 21.4H20.4444V19.0461L18.332 21.4ZM20.4444 16.6872L16.215 21.4H12.6667V11.8H20.4444V16.6872ZM18.1111 8.6V10.2H12.6667C11.8076 10.2 11.1111 10.9163 11.1111 11.8V19H9.55556V8.6H18.1111Z",
    fill: "#FC2B6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 14.2C14.2222 13.7582 14.5704 13.4 15 13.4H18.1111C18.5407 13.4 18.8889 13.7582 18.8889 14.2C18.8889 14.6418 18.5407 15 18.1111 15H15C14.5704 15 14.2222 14.6418 14.2222 14.2Z",
    stroke: "#FFDFEA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.8C14.5704 15.8 14.2222 16.1582 14.2222 16.6C14.2222 17.0418 14.5704 17.4 15 17.4H18.1111C18.5407 17.4 18.8889 17.0418 18.8889 16.6C18.8889 16.1582 18.5407 15.8 18.1111 15.8H15Z",
    stroke: "#FFDFEA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.6C8 7.71634 8.69645 7 9.55556 7H18.1111C18.9702 7 19.6667 7.71634 19.6667 8.6V10.2H20.4444C21.3036 10.2 22 10.9163 22 11.8V21.4C22 22.2837 21.3036 23 20.4444 23H12.6667C11.8076 23 11.1111 22.2837 11.1111 21.4V20.6H9.55556C8.69645 20.6 8 19.8837 8 19V8.6ZM18.332 21.4H20.4444V19.0461L18.332 21.4ZM20.4444 16.6872L16.215 21.4H12.6667V11.8H20.4444V16.6872ZM18.1111 8.6V10.2H12.6667C11.8076 10.2 11.1111 10.9163 11.1111 11.8V19H9.55556V8.6H18.1111Z",
    stroke: "#FFDFEA",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDetailChatIcon);
export default __webpack_public_path__ + "static/media/OrderDetailChatIcon.b0a8a63010a3ea8fa19c270694657df8.svg";
export { ForwardRef as ReactComponent };